/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Trouble_Win_Gpu_AInputs */

const en_wc_dl_trouble_win_gpu_a = /** @type {(inputs: Wc_Dl_Trouble_Win_Gpu_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft uses DirectX 12 by default. Some graphics drivers crash on start; try the Vulkan backend from PowerShell in the app folder:`)
};

/**
* | output |
* | --- |
* | "WordCraft uses DirectX 12 by default. Some graphics drivers crash on start; try the Vulkan backend from PowerShell in the app folder:" |
*
* @param {Wc_Dl_Trouble_Win_Gpu_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_trouble_win_gpu_a = /** @type {((inputs?: Wc_Dl_Trouble_Win_Gpu_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Trouble_Win_Gpu_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_trouble_win_gpu_a(inputs)
});
export { wc_dl_trouble_win_gpu_a as "wc.dl.trouble.win_gpu.a" }